'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIList from 'UIComponents/list/UIList';
import getErrorNotificationBody, { getPermissionsError } from './ErrorNotificationBody';
import { PERMISSIONS_ERROR_STRINGS } from 'AdsUI/lib/Constants';
import { getAdAccounts } from 'AdsUI/selectors/AccountsSelectors';
const MAX_ERRORS = 5;
export default ((messageKey, errorMessageKey) => (action, getState) => {
  const errors = action.payload && (action.payload.errors || action.payload.accountErrors);

  if (!errors || !errors.length) {
    return null;
  }

  if (errors.every(err => PERMISSIONS_ERROR_STRINGS.some(permissionError => err.errorMessage.indexOf(permissionError) > -1))) {
    const {
      adNetwork,
      id
    } = errors[0];
    const adAccounts = getAdAccounts(getState());
    return getPermissionsError({
      network: adNetwork,
      adAccount: adAccounts.find(account => account.accountId === id && account.network === adNetwork)
    });
  }

  return getErrorNotificationBody({
    id: messageKey,
    actionType: action.type,
    text: /*#__PURE__*/_jsx(FormattedMessage, {
      message: messageKey
    }),
    details: /*#__PURE__*/_jsxs(UIList, {
      children: [errors.slice(0, MAX_ERRORS).map(error => /*#__PURE__*/_jsx(FormattedMessage, {
        message: errorMessageKey,
        options: error
      }, error.id)), errors.length > MAX_ERRORS && /*#__PURE__*/_jsx(FormattedMessage, {
        message: "andMoreErrors",
        options: {
          count: errors.length - MAX_ERRORS
        }
      })]
    })
  });
});